export class Message {
  title: string;
  icon: string;
  text: string;
  showCloseButtonX: boolean;
  showCloseButton: boolean;
  showOkButton: boolean;
  closeButtonText: string;
  okButtonText: string;
  boldTitle: boolean;

  constructor() {
    this.showCloseButtonX = true;
    this.boldTitle = false;
  }
}
